// replaces the values in the first object with the values of matching keys (with non null/undefined values) in the second object. non-overlapping keys from the second object are ignored, and non-overlapping keys from the first object are preserved.
export const overlap = (main, added) =>
  Object.entries(main).reduce((updatedObject, [key, val]) => {
    updatedObject[key] = added[key] ?? val;
    return updatedObject;
  }, {});
